<template>
	<div class="tools-main-wrap">
		<!-- 历史会话栏（参考 app/chat 的轮次/历史会话管理） -->
		<div class="lunci-panel">
			<div class="panel-header">
				<span class="panel-title">聊天历史</span>
				<el-button type="primary" size="mini" icon="el-icon-plus" circle @click="createNewChat"></el-button>
			</div>
			<div class="lunci-list" v-loading="sessionLoading">
				<div v-for="item in chatList" :key="item.guid"
					:class="['lunci-item', { active: chatingId === item.guid }]" @click="selectChat(item)">
					<div class="lunci-row">
						<i v-if="item.isTop" class="el-icon-top top-flag" title="已置顶"></i>
						<span class="lunci-title" :title="item.chatLunciTitle">{{ item.chatLunciTitle }}</span>
					</div>
					<div class="lunci-meta">
						<span class="lunci-time">{{ item.showTime }}</span>
						<span class="lunci-ops" @click.stop>
							<i class="el-icon-edit" title="重命名" @click="renameChat(item)"></i>
							<i :class="item.isTop ? 'el-icon-download' : 'el-icon-top'"
								:title="item.isTop ? '取消置顶' : '置顶'" @click="toggleTop(item)"></i>
							<el-popconfirm title="确定删除该对话吗？" @confirm="removeChatHandler(item)">
								<i slot="reference" class="el-icon-delete" title="删除"></i>
							</el-popconfirm>
						</span>
					</div>
				</div>
				<div v-if="!sessionLoading && chatList.length === 0" class="lunci-empty">暂无对话，点击右上角 + 新建</div>
			</div>
		</div>

		<div class="layout-chat-main">
			<div class="chat-header">{{ classDetail.title }}</div>
			<chat-box id="chatbox" ref="chatBox" :_chatDialogs="chatDialogs" v-loading="dialogsLoading"></chat-box>
			<div class="chat-input">
				<div class="opt-panel mb4">
					<!-- <el-button @click="cleanDialogs" size="mini" round class="mr4">
						<i class="iconfont el-icon-brush mr4"></i> 清除聊天记录
					</el-button> -->
					<div class="clean-chat-btn mr4" @click="cleanDialogs">清除聊天记录</div>
				</div>
				<div class="chat-input-box">
					<div class="input-box">
						<el-input type="textarea" @keyup.enter.native="send" :rows="2" placeholder="请输入内容" v-model="msgText"
							resize="none"></el-input>
					</div>
					<!-- <el-button type="primary" @click="send" class="send" size="small">发送</el-button> -->
					<div class="send-icon">
						<img class="icon" @click="send" src="../../../static/icon/send-icon.png" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ChatBox from '@/views/app/layout-chat/chat-box.vue';
import { getClassDetailApi, saveMsgApi, saveToolMsgContentApi, nowLunciApi } from '@/apis/tools';
import { getChatList, createChat, getChatDialogs, removeChat, setLunciTopApi, updateChat } from '@/apis/chat';
import config from '@/apis/config'

// 文案工具对话的聊天场景：对应 hms_copywriting_category，sceneValue 为文案分类 id
const CHAT_SCENE = 'copywriting';
export default {
	name: 'layout-tools-main',
	components: { ChatBox },
	async created() {

	},
	props: {
		toolId: Number,
	},

	data() {
		return {
			config,
			msgText: '',
			sendReq: {
				msgId: '',
				content_cate_id: 0,
				background_id: 0,
				isSend: false,
			},
			chatDialogs: [],
			// 历史轮次相关
			chatList: [],          // 当前文案分类下的历史轮次列表
			chatingId: '',         // 当前选中的轮次 guid
			sessionLoading: false, // 历史列表加载中
			dialogsLoading: false, // 某轮消息加载中
			classDetail: {
				title: '',
			},
			timeoutVar: 0,
			msgId: '',
			msgReqParame: {
				role: 'user',
				content: '',
				lastMsgId: '',
				aiModelGuid: '',
				chatLunciGuid: '',
			},
			msgReqAiParame: {
				role: 'assistant',
				content: '',
				lastMsgId: '',
				aiModelGuid: '',
				chatLunciGuid: '',
			},
			saveTextReq: {
				title: '',
				workResult: '',
				copywritingCategoryId: '',
				msgId: '',
			},
			//判断当前是否在发送消息中
			isNewGlobalMsg: false,
		};
	},

	computed: {},
	watch: {
		async toolId(id) {
			this.sendReq.content_cate_id = id;
			this.chatDialogs = [];
			this.chatingId = '';
			this.msgId = '';
			// 先取分类详情（含 ai_model / able_lunci / title），发送链路依赖它
			try {
				let res = await getClassDetailApi({ cateId: id });
				this.classDetail = res.data;
				this.sendReq.isSend = true;
			} catch (error) { }
			// 确保该分类下存在一个“当前轮次”（无则自动创建），并加载历史列表
			try {
				let lunci = await nowLunciApi({
					chatScene: CHAT_SCENE,
					sceneValue: id
				});
				await this.loadChatList();
				// 默认续上该分类最近一轮
				this.chatingId = lunci.data;
			} catch (error) { }
		},
		// 切换轮次：加载该轮历史消息
		async chatingId(id) {
			if (!id) return;
			this.msgReqParame.chatLunciGuid = id;
			this.msgReqAiParame.chatLunciGuid = id;
			this.dialogsLoading = true;
			const requestedId = id;
			try {
				const chats = await getChatDialogs({ chatLunciGuid: id });
				// 防并发：返回时若已切到别的轮次，丢弃结果
				if (this.chatingId !== requestedId) return;
				chats.forEach(item => {
					item.starting = false;
					item.finished = true;
					if (item.chatRole === 'assistant') {
						if (item.contentType === 'img') {
							item.imgUrls = (item.imgUrls && item.imgUrls.length) ? item.imgUrls : [item.chatContent];
							item.chatContent = '';
						} else if (item.contentType === 'video') {
							item.videoUrls = (item.videoUrls && item.videoUrls.length) ? item.videoUrls : [item.chatContent];
							item.chatContent = '';
						}
					}
					if (!Array.isArray(item.imgUrls)) item.imgUrls = [];
				});
				this.chatDialogs = chats;
				// 维持上下文连续性：able_lunci 开启时，lastMsgId 接到本轮最后一条
				if (this.classDetail.able_lunci === 1 && chats.length > 0) {
					this.msgId = chats[chats.length - 1].msgId || '';
				} else {
					this.msgId = '';
				}
			} catch (error) {
				this.$message({ message: '加载历史消息失败', type: 'error' });
			} finally {
				if (this.chatingId === requestedId) {
					this.dialogsLoading = false;
				}
			}
		},
	},
	methods: {
		cleanDialogs() {
			this.chatDialogs = [];
		},
		// 加载当前文案分类下的历史轮次列表
		async loadChatList() {
			this.sessionLoading = true;
			try {
				let list = await getChatList({ chatScene: CHAT_SCENE, sceneValue: this.sendReq.content_cate_id });
				this.chatList = Array.isArray(list) ? list : [];
			} catch (error) {
				this.chatList = [];
			} finally {
				this.sessionLoading = false;
			}
		},
		// 新建轮次
		async createNewChat() {
			if (!this.sendReq.content_cate_id) return;
			try {
				let res = await createChat({
					chatScene: CHAT_SCENE,
					sceneValue: this.sendReq.content_cate_id,
					chatLunciTitle: '新对话',
				});
				await this.loadChatList();
				let newGuid = res && res.data ? res.data : '';
				if (newGuid) this.chatingId = newGuid;
			} catch (error) {
				this.$message({ message: '新建对话失败', type: 'error' });
			}
		},
		// 切换轮次
		selectChat(item) {
			if (this.chatingId === item.guid) return;
			this.chatingId = item.guid;
		},
		// 删除轮次
		async removeChatHandler(item) {
			try {
				await removeChat({ chatLunciGuid: item.guid });
				let deletingCurrent = this.chatingId === item.guid;
				await this.loadChatList();
				if (deletingCurrent) {
					if (this.chatList.length > 0) {
						this.chatingId = this.chatList[0].guid;
					} else {
						this.chatingId = '';
						this.chatDialogs = [];
						await this.createNewChat();
					}
				}
				this.$message({ message: '已删除', type: 'success' });
			} catch (error) {
				this.$message({ message: '删除失败', type: 'error' });
			}
		},
		// 置顶 / 取消置顶
		async toggleTop(item) {
			let targetIsTop = item.isTop ? 0 : 1;
			try {
				let res = await setLunciTopApi(item.guid, targetIsTop);
				if (res && res.code === 0) {
					this.$message({ message: targetIsTop ? '已置顶' : '已取消置顶', type: 'success' });
					await this.loadChatList();
				}
			} catch (error) {
				this.$message({ message: '操作失败', type: 'error' });
			}
		},
		// 重命名轮次
		async renameChat(item) {
			let value;
			try {
				let prompt = await this.$prompt('请输入新的对话名称', '重命名', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputValue: item.chatLunciTitle,
					inputValidator: (val) => (val && val.trim().length > 0) ? true : '名称不能为空',
				});
				value = prompt.value.trim();
			} catch (e) {
				return; // 用户取消
			}
			if (value === item.chatLunciTitle) return;
			try {
				await updateChat(item.guid, value);
				this.$message({ message: '已重命名', type: 'success' });
				await this.loadChatList();
			} catch (error) {
				this.$message({ message: '重命名失败', type: 'error' });
			}
		},
		async send() {
			this.submitQuestion(this.msgText);
		},
		async submitQuestion(content) {
			if (!this.sendReq.isSend) {
				this.$message({ message: 'AI模型错误或正在生成中，请稍后重试...', type: 'warning' });
				return;
			}
			if (content.trim().length === 0) {
				this.$message({
					message: '请输入问题 ...',
					type: 'warning',
				});
				return;
			}
			if (this.isNewGlobalMsg) {
				this.$message({
					message: 'AI正在回答中 ...',
					type: 'warning',
				});
				return;
			}
			//设置消息发送中状态
			this.isNewGlobalMsg = true;
			this.msgReqParame.content = content;
			this.msgReqParame.aiModelGuid = this.classDetail.ai_model;
			this.saveTextReq.title = content;
			//写入用户发送的消息
			// let newUserMsg = {
			// 	role: 'user',
			// 	content: content,
			// 	msgId: '',
			// };
			// this.msg.push(newUserMsg);
			try {
				this.chatDialogs.push({ msgId: 'new', chatRole: 'user', chatContent: content, imgUrls: [] });
				this.chatDialogs.push({
					msgId: 'new',
					chatRole: 'assistant',
					chatContent: '',
					starting: true,
					finished: false,
				});
				//更新msgID
				this.msgReqParame.lastMsgId = this.msgId;
				let res = await saveMsgApi(this.msgReqParame);

				let dialog = this.chatDialogs[this.chatDialogs.length - 1];
				if (res.code !== 0) {
					dialog.starting = false;
					dialog.finished = true;
					dialog.chatContent = res.msg ? res.msg : '算力繁忙，请稍候重试';
					return;
				}
				this.msgText = '';
				this.sendReq.msgId = res.data.msgId;
				this.msgId = res.data.msgId;
				// this.createContact();
				this.waitChat(res.data.msgId);
			} catch (error) {
				//出现错误时重置msgid
				this.sendReq.msgId = '';
				// this.msg[this.nowAiMsgIndex].isNewMsg = false;
				let dialog = this.chatDialogs[this.chatDialogs.length - 1];
				dialog.starting = false;
				dialog.chatContent = '算力繁忙，请稍候重试';
				this.isNewGlobalMsg = false;
				this.msgText = '';
				return;
			}
		},
		// async createContact() {
		// 	try {
		// 		let dialog = this.chatDialogs[this.chatDialogs.length - 1];
		// 		let msg = await getAiMsgApi(this.sendReq);
		// 		this.isNewGlobalMsg = false;
		// 		this.saveTextReq.workResult = msg.data;
		// 		this.msgReqAiParame.content = msg.data;
		// 		//更新msgID
		// 		this.msgReqAiParame.lastMsgId = this.msgId;
		// 		dialog.starting = false;
		// 		dialog.chatContent = msg.data;
		// 		let msgId = await saveMsgApi(this.msgReqAiParame);
		// 		//是否开启对话上下文
		// 		if (this.classDetail.able_lunci === 1) {
		// 			this.msgId = msgId.data.msgId;
		// 		}
		// 		this.saveTextReq.msgId = msgId.data.msgId;
		// 		await this.saveToolMsgContent();
		// 	} catch (error) {
		// 		let dialog = this.chatDialogs[this.chatDialogs.length - 1];
		// 		this.isNewGlobalMsg = false;
		// 		dialog.starting = false;
		// 		dialog.chatContent = '算力繁忙，请稍候重试';
		// 	}
		// },
		async waitChat(lastMsgId) {
			let dialog = this.chatDialogs[this.chatDialogs.length - 1];
			let then = this;
			let link = `${config.baseUrl}square/api.chat/sendOpen?content_cate_id=${this.sendReq.content_cate_id}&msgId=${lastMsgId}&aiModelGuid=${this.classDetail.ai_model}`;
			const source = new EventSource(link);
			source.onmessage = async function ({ data }) {
				data && (dialog.starting = false);
				if (data == '[DONE]') {
					// dialog.msgId = await saveChatDialog({
					// 	role: 'assistant',
					// 	content: dialog.chatContent,
					// 	lastMsgId,
					// 	chatLunciGuid: self._chatingId,
					// 	model: self.selectModelKey,
					// });
					dialog.finished = true;
					then.msgReqAiParame.content = dialog.chatContent;
					//更新msgID
					then.msgReqAiParame.lastMsgId = then.msgId;
					then.msgReqAiParame.aiModelGuid = then.classDetail.ai_model;
					let msgId = await saveMsgApi(then.msgReqAiParame);
					//是否开启对话上下文
					if (then.classDetail.able_lunci === 1) {
						then.msgId = msgId.data.msgId;
					}
					then.saveTextReq.msgId = msgId.data.msgId;
					then.isNewGlobalMsg = false;
					// await then.saveToolMsgContent();
					// 刷新历史列表（更新排序/标题），不打断当前会话
					then.loadChatList();
					source.close();
				} else {
					dialog.chatContent += data.replace(/\\n/g, '\n');
				}
			};

			source.onopen = function (event) {
				console.log('Connection was opened');
				// dialog.starting = false
			};

			source.onerror = async function (event) {
				// console.log('event : ', event)
				// dialog.chatContent += '[ ERROR ]'
				source.close();
			};
		},
		async saveToolMsgContent() {
			await saveToolMsgContentApi(this.saveTextReq);
		},
		// 滚动到最底部
		toBottom() {
			this.$nextTick(() => {
				let scrollDom = document.getElementById('chatbox');
				scrollDom.scrollTop = scrollDom.scrollHeight;
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.tools-main-wrap {
	width: 100%;
	height: 100%;
	display: flex;
	flex: 1;
	min-width: 0;
}

.lunci-panel {
	width: 230px;
	flex-shrink: 0;
	order: 2; // 历史栏放到聊天区右侧
	border-left: 1px solid var(--border-color);
	background-color: #fff;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;

	.panel-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 12px 14px;
		border-bottom: 1px solid var(--border-color);

		.panel-title {
			font-size: 14px;
			font-weight: 500;
			color: #222;
		}
	}

	.lunci-list {
		flex: 1;
		overflow-y: auto;
		padding: 8px;

		.lunci-item {
			padding: 8px 10px;
			margin-bottom: 6px;
			border-radius: 8px;
			background: #fafbfc;
			cursor: pointer;
			transition: background 0.15s;

			&:hover {
				background: #f0f2ff;
			}

			&.active {
				background: #f0f2ff;

				.lunci-title {
					color: #4958ec;
					font-weight: 500;
				}
			}

			.lunci-row {
				display: flex;
				align-items: center;
				gap: 4px;

				.top-flag {
					color: #f56c6c;
					font-size: 12px;
				}

				.lunci-title {
					flex: 1;
					font-size: 13px;
					color: #333;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}

			.lunci-meta {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 4px;

				.lunci-time {
					font-size: 12px;
					color: #999;
				}

				.lunci-ops {
					display: flex;
					gap: 8px;

					i {
						font-size: 13px;
						color: #999;
						cursor: pointer;

						&:hover {
							color: #4958ec;
						}
					}
				}
			}
		}

		.lunci-empty {
			text-align: center;
			color: #999;
			font-size: 12px;
			padding: 20px 10px;
		}
	}
}

.layout-chat-main {
	flex: 1;
	height: 100%;
	min-width: 0;
	order: 1; // 聊天区在左，历史栏在右

	display: flex;
	flex-direction: column;

	.chat-header {
		border-bottom: 1px solid var(--border-color);
		padding: 14px 20px;
	}

	.chat-input {
		border-top: 1px solid var(--border-color);
		padding: 10px 20px;

		.chat-input-box {
			border-radius: 10px;
			border: 1px solid #e1e2e5;
			position: relative;
			display: flex;
			align-items: center;
			padding-right: 10px;

			.input-box {
				::v-deep .el-textarea__inner {
					border: none;
					border-radius: 10px;
					font-size: 12px;
				}

				flex: 1;
			}

			.send-icon {
				cursor: pointer;

				.icon {
					width: 34px;
					height: 34px;
					display: block;
				}
			}
		}
	}

	.chat-box {
		flex: 1 1;
		overflow: auto;
		padding: 10px 0;
	}

	.opt-panel {
		margin-bottom: 10px;
		display: flex;

		// .el-button {
		//   padding: 2px 11px;
		//   font-size: 12px;
		//   font-weight: normal;

		//   i {
		//     font-size: 12px;
		//   }
		// }

		.clean-chat-btn {
			border-radius: 8px;
			border: 1px solid #dee0e4;
			font-size: 12px;
			color: #737b8d;
			cursor: pointer;
			padding: 6px 10px;
			overflow: hidden;
			/* 确保超出容器的文本被隐藏 */
			white-space: nowrap;
			/* 防止文本换行 */
			text-overflow: ellipsis;

			&:hover {
				border-color: #f6f7f9;
				background: #f6f7f9;
			}
		}
	}
}
</style>
